// extracted by mini-css-extract-plugin
module.exports = {"meduaUpload":"QuestionThumbnail_meduaUpload__1ydJw"};